




















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { IOcojoImageSource } from "../../../../../../domain/ocojo";
import { IImageDragParameter } from "../../../../../dragging";
import { Size } from "../../../../../../domain/drawing";
import leftIcon from "@/assets/icon_left_jp.png";
import rightIcon from "@/assets/icon_right_jp.png";
import movieIcon from "@/assets/icon_movie.png";
import * as Moment from "moment";

@Component({
  components: {
  }
})
export default class OcojoImageThumbnail extends Mixins() {
  data(): any {
    return {
      imageWidthText: null,
      imageHeightText: null,
    };
  }
  imageWidthText: string;
  imageHeightText: string;

  @Prop()
  size: Size;

  @Prop()
  isFocused: boolean;

  @Prop()
  ocojoImageSource: IOcojoImageSource;

  get rootStyleProperties(): any {
    return {
      width: this.size.width + "px",
      height: this.size.height + "px",
      outline: this.isFocused ? "2px solid rgba(255, 0, 0, 0.5)" : "none",
    };
  }

  get thumbnailImageStyleProperties(): any {
    return {
      position: "absolute",
      maxWidth: this.size.width + "px",
      maxHeight: this.size.height + "px",
    };
  }

  get thumbnailImageSource(): string {
    return this.ocojoImageSource.thumbnailSource;
  }

  get isLeftImage(): boolean {
    return this.ocojoImageSource.isLeft;
  }

  get leftIconImageSource() {
    return leftIcon;
  }

  get isRightImage(): boolean {
    return this.ocojoImageSource.isRight;
  }

  get rightIconImageSource() {
    return rightIcon;
  }

  get isMovieImage(): boolean {
    return this.ocojoImageSource.isMovie;
  }

  get movieIconImageSource() {
    return movieIcon;
  }

  get description(): string {
    // TODO: 時刻・登録診療科も見れたほうがよい？
    if (this.ocojoImageSource.imageDate) {
      const moment = Moment(this.ocojoImageSource.imageDate);
      return moment.format("YYYY/MM/DD");
    }
  }

  adjustImageSize(): void {
    const image = this.$refs.image as HTMLImageElement;
    if (!image) { return; }
    // 比率が大きい方に合わせる
    const ratioWidth = image.naturalWidth / this.size.width;
    const ratioHeight = image.naturalHeight / this.size.height;
    this.imageWidthText = (ratioWidth >= ratioHeight) ? "100%" : null;
    this.imageHeightText = (ratioWidth <= ratioHeight) ? "100%" : null;
  }

  onDragStart(event: DragEvent): void {
    const data: IImageDragParameter = {
      isOcojoImage: true,
      ocojoImageDragParameter: {
        patientId: this.ocojoImageSource.patientId,
        imageId: this.ocojoImageSource.claioImageKey,
        isVisibleLayer: !!this.ocojoImageSource.isVisibleLayer,
        isMovie: !!this.ocojoImageSource.isMovie,
        isSecret: !!this.ocojoImageSource.isSecret,
        imageDepartmentId: this.ocojoImageSource.departmentId,
      }
    };
    const text = JSON.stringify(data);
    // 第一引数(format)が"text"でないとIEでエラーになる。
    event.dataTransfer.setData("text", text);
  }

  onThumbnailSelected(event: PointerEvent): void {
    this.selected(this.ocojoImageSource);
  }

  @Emit()
  selected(src: IOcojoImageSource): void {}

  onThumbnailDoubleClicked(): void {
    this.doubleClick(this.ocojoImageSource);
  }

  @Emit()
  doubleClick(src: IOcojoImageSource): void {}
}
